var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "address-card" }, [
    _c("div", { staticClass: "address-card__header" }, [
      _c("h3", { staticClass: "typographies-heading-h3" }, [
        _vm._v(_vm._s(_vm.address.name))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "address-card__actions-container" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.textTooltipDelete,
                disabled: _vm.canDeleteAddress,
                arrow: false,
                placement: "bottom-end"
              }
            },
            [
              _c("CompassIconButton", {
                attrs: {
                  icon: "bin",
                  variant: "destructive",
                  disabled: _vm.disableDeleteButton
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("onDelete")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.$t.__(
                  "common.labels.no_permissions_to_perform_this_action"
                ),
                disabled: _vm.permissions.can_edit_addresses,
                arrow: false,
                placement: "bottom-end"
              }
            },
            [
              _c("CompassIconButton", {
                attrs: { icon: "edit", disabled: _vm.disableEditButton },
                on: {
                  click: function($event) {
                    return _vm.$emit("onEdit", _vm.address)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
      _c("p", [_vm._v(_vm._s(_vm.address.address_line_1))]),
      _vm._v(" "),
      _vm.address.address_line_2
        ? _c("p", [_vm._v(_vm._s(_vm.address.address_line_2))])
        : _vm._e(),
      _vm._v(" "),
      _vm.address.address_line_3
        ? _c("p", [_vm._v(_vm._s(_vm.address.address_line_3))])
        : _vm._e(),
      _vm._v(" "),
      _vm.address.address_line_4
        ? _c("p", [_vm._v(_vm._s(_vm.address.address_line_4))])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(_vm.address.city) + ", " + _vm._s(_vm.address.postal_code)
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            " + _vm._s(_vm.address.country) + "\n        ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "address-card__switch-container" },
      [
        _c(
          "CompassTooltip",
          {
            attrs: {
              content: _vm.$t.__(
                "common.labels.no_permissions_to_perform_this_action"
              ),
              arrow: false,
              disabled: _vm.permissions.can_edit_addresses
            }
          },
          [
            _c("CompassSwitch", {
              attrs: {
                value: _vm.localInvoicingAddressSwitch,
                disabled: _vm.isSwitchInvoicingDisabled,
                label: _vm.labelSwitchInvoicing,
                orientation: "left"
              },
              on: { change: _vm.handleInvoicingAddressSwitch }
            }),
            _vm._v(" "),
            _vm.isSwitchInvoicingLoading
              ? _c("CompassLoader", { attrs: { size: "small" } })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "CompassTooltip",
          {
            attrs: {
              content: _vm.$t.__(
                "common.labels.no_permissions_to_perform_this_action"
              ),
              arrow: false,
              disabled: _vm.permissions.can_edit_addresses
            }
          },
          [
            _c("CompassSwitch", {
              attrs: {
                value: _vm.localDeliveryAddressSwitch,
                disabled: _vm.isSwitchDeliveryDisabled,
                label: _vm.labelSwitchDelivery,
                orientation: "left"
              },
              on: { change: _vm.handleDeliveryAddressSwitch }
            }),
            _vm._v(" "),
            _vm.isSwitchDeliveryLoading
              ? _c("CompassLoader", { attrs: { size: "small" } })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }